import Scrolling from '../utils/class/scrolling';

const QUERIES = {
    menu: '.site-menu',
    toggle: '.site-menu-toggle',
    close: null
}

const BREAKPOINT = 1199;

/**
 * This feature is used to set mobile menu behavior
 * 
 * @class Menu
 * @param {Object} [queries]
 * @param {string|number} [breakpoint]
 */

export default class Menu {
    constructor (queries = QUERIES, breakpoint = BREAKPOINT) {
        const menu = document.querySelector(queries.menu) || document.querySelector(QUERIES.menu);
        if (!menu) throw new Error('Menu not found');

        const toggle = document.querySelector(queries.toggle) || document.querySelector(QUERIES.toggle);
        if (!toggle) throw new Error('Toggle not found');

        const close = queries.close ? document.querySelector(queries.close) : QUERIES.close;

        this.menu = menu;
        this.wrapper = menu.parentNode;
        this.toggle = toggle;
        this.close = close;
        this.breakpoint = breakpoint || BREAKPOINT;
        this.scrolling = new Scrolling();

        this.init();
    }

    init () {
        const controls = document.querySelector('.menu-controls');

        if (controls) this.menu.append(controls);

        const profile = document.querySelector('.menu-profile');

        if (profile) this.menu.querySelector('*:first-child').before(profile);

        this.handleToggle();
        this.handleResize();
    }

    handleToggle () {
        if (!this.close) {
            this.toggle.addEventListener('click', (event) => {
                event.stopPropagation();

                const opened = this.menu.classList.contains('opened');

                if (!opened) this.handleOpen();
                if (opened) this.handleClose();
            });
        } else {
            this.toggle.addEventListener('click', (event) => {
                event.stopPropagation();

                this.handleOpen();
            });

            this.close.addEventListener('click', (event) => {
                event.stopPropagation();

                this.handleClose();
            })
        }
    }

    handleResize () {
        window.addEventListener('resize', (event) => {
            event.stopPropagation();

            if (window.innerWidth > this.breakpoint) this.handleClose();
        });
    }

    handleOpen () {
        if (this.wrapper) this.wrapper.classList.add('opened');

        this.menu.classList.add('opened');
        this.toggle.classList.add('opened');

        this.scrolling.disable();
    }

    handleClose () {
        if (this.wrapper) this.wrapper.classList.remove('opened');

        this.menu.classList.remove('opened');
        this.toggle.classList.remove('opened');

        this.scrolling.enable();
    }
}

/**
 * Usage example
 * 
 * import Menu from 'components/menu';
 * 
 * const menu = new Menu({
 *  menu: '.site-menu',
 *  toggle: '.site-menu-toggle',
 *  close: '.site-menu-close'
 * });
 * 
 * menu.open();
 * menu.close();
 * 
 */
